import styled from 'styled-components/macro';
import autobg from 'autobg.macro';
import vw from 'rpf/un/vw';
import LongPage from 'rpf/react/components/LongPage';

export const Wrap = styled(LongPage)`
  position: relative;
  background-color: #484886;
`;

export const Bg = styled.div`
  ${autobg('assets/img/list/bg.png')}
`;

export const Content = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: ${vw(1700)};
  padding-top: ${vw(490)};
`;

export const Block = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: ${vw(712)};
  height: ${vw(222)};
  margin: 0 auto ${vw(45)};
  padding: 0 ${vw(20)} 0 ${vw(30)};
  background-color: #ffffff;
  border-radius: ${vw(20)};
`;

export const TextWrap = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
`;

export const Title = styled.div`
  margin-bottom: ${vw(18)};
  font-size: ${vw(42)};
  font-weight: bold;
  color: #323232;
`;

export const Desc = styled.div`
  width: ${vw(380)};
  font-size: ${vw(26)};
  color: #6e6f6e;
  line-height: 1.6;
`;

export const CardWrap = styled.div`
  width: ${vw(233)};
`;

export const Card = styled.div`
  ${p => p.img}
  margin: 0 auto;
`;

export const ReturnBtn = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${vw(227)};
  height: ${vw(58)};
  margin: 0 auto;
  background-color: #ffffff;
  border-radius: ${vw(29)};
  font-size: ${vw(28)};
  color: #2f2f60;
`;
